/* tslint:disable */
/**
* @module SDKModule
* @author Jonathan Casarrubias <t:@johncasarrubias> <gh:jonathan-casarrubias>
* @license MIT 2016 Jonathan Casarrubias
* @version 2.1.0
* @description
* The SDKModule is a generated Software Development Kit automatically built by
* the LoopBack SDK Builder open source module.
*
* The SDKModule provides Angular 2 >= RC.5 support, which means that NgModules
* can import this Software Development Kit as follows:
*
*
* APP Route Module Context
* ============================================================================
* import { NgModule }       from '@angular/core';
* import { BrowserModule }  from '@angular/platform-browser';
* // App Root 
* import { AppComponent }   from './app.component';
* // Feature Modules
* import { SDK[Browser|Node|Native]Module } from './shared/sdk/sdk.module';
* // Import Routing
* import { routing }        from './app.routing';
* @NgModule({
*  imports: [
*    BrowserModule,
*    routing,
*    SDK[Browser|Node|Native]Module.forRoot()
*  ],
*  declarations: [ AppComponent ],
*  bootstrap:    [ AppComponent ]
* })
* export class AppModule { }
*
**/
import { ErrorHandler } from './services/core/error.service';
import { LoopBackAuth } from './services/core/auth.service';
import { LoggerService } from './services/custom/logger.service';
import { SDKModels } from './services/custom/SDKModels';
import { InternalStorage, SDKStorage } from './storage/storage.swaps';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CookieBrowser } from './storage/cookie.browser';
import { StorageBrowser } from './storage/storage.browser';
import { SocketBrowser } from './sockets/socket.browser';
import { SocketDriver } from './sockets/socket.driver';
import { SocketConnection } from './sockets/socket.connections';
import { RealTime } from './services/core/real.time';
import { AdminApi } from './services/custom/Admin';
import { PlayerApi } from './services/custom/Player';
import { SocialAccountApi } from './services/custom/SocialAccount';
import { GameApi } from './services/custom/Game';
import { PrizeApi } from './services/custom/Prize';
import { EmojiApi } from './services/custom/Emoji';
import { GameEmojiApi } from './services/custom/GameEmoji';
import { GamePlayerApi } from './services/custom/GamePlayer';
import { GamePlayerEmojiApi } from './services/custom/GamePlayerEmoji';
import { EmailApi } from './services/custom/Email';
import { ContainerApi } from './services/custom/Container';
import { ResourceApi } from './services/custom/Resource';
import { GameCategoryApi } from './services/custom/GameCategory';
import { PlayerShareApi } from './services/custom/PlayerShare';
import { ContentApi } from './services/custom/Content';
import { InquiryApi } from './services/custom/Inquiry';
import { LanguageApi } from './services/custom/Language';
import { TranslationApi } from './services/custom/Translation';
import { DonationCategoryApi } from './services/custom/DonationCategory';
import { OrganizationApi } from './services/custom/Organization';
import { PlayerPrizeApi } from './services/custom/PlayerPrize';
import { ProxyApi } from './services/custom/Proxy';
import { NotificationApi } from './services/custom/Notification';
import { PlayerNotificationApi } from './services/custom/PlayerNotification';
import { PlayerMetaApi } from './services/custom/PlayerMeta';
import { SurveyApi } from './services/custom/Survey';
import { PlayerSurveyApi } from './services/custom/PlayerSurvey';
import { PlayerGameCategoryApi } from './services/custom/PlayerGameCategory';
import { RewardApi } from './services/custom/Reward';
import { PlayerRewardApi } from './services/custom/PlayerReward';
/**
* @module SDKBrowserModule
* @description
* This module should be imported when building a Web Application in the following scenarios:
*
*  1.- Regular web application
*  2.- Angular universal application (Browser Portion)
*  3.- Progressive applications (Angular Mobile, Ionic, WebViews, etc)
**/
@NgModule({
  imports:      [ CommonModule, HttpClientModule ],
  declarations: [ ],
  exports:      [ ],
  providers:    [
    ErrorHandler,
    SocketConnection
  ]
})
export class SDKBrowserModule {
  static forRoot(internalStorageProvider: any = {
    provide: InternalStorage,
    useClass: CookieBrowser
  }): ModuleWithProviders {
    return {
      ngModule  : SDKBrowserModule,
      providers : [
        LoopBackAuth,
        LoggerService,
        SDKModels,
        RealTime,
        AdminApi,
        PlayerApi,
        SocialAccountApi,
        GameApi,
        PrizeApi,
        EmojiApi,
        GameEmojiApi,
        GamePlayerApi,
        GamePlayerEmojiApi,
        EmailApi,
        ContainerApi,
        ResourceApi,
        GameCategoryApi,
        PlayerShareApi,
        ContentApi,
        InquiryApi,
        LanguageApi,
        TranslationApi,
        DonationCategoryApi,
        OrganizationApi,
        PlayerPrizeApi,
        ProxyApi,
        NotificationApi,
        PlayerNotificationApi,
        PlayerMetaApi,
        SurveyApi,
        PlayerSurveyApi,
        PlayerGameCategoryApi,
        RewardApi,
        PlayerRewardApi,
        internalStorageProvider,
        { provide: SDKStorage, useClass: StorageBrowser },
        { provide: SocketDriver, useClass: SocketBrowser }
      ]
    };
  }
}
/**
* Have Fun!!!
* - Jon
**/
export * from './models/index';
export * from './services/index';
export * from './lb.config';
export * from './storage/storage.swaps';
export { CookieBrowser } from './storage/cookie.browser';
export { StorageBrowser } from './storage/storage.browser';

